module.exports = __webpack_public_path__ + "static/media/mg7.0dd34369.png";